if (window.customElements && window.customElements.define) {
  require("lib/components/avatar/avatar")
} else {
  require("lib/components/avatar/avatar-legacy")
}
